import axios from "axios";

export interface ContributionResp {
   id: string;
   title: string;
   type: string;
   data: any;
   endDate: string;
   externalUrl: string;
   externalId: string;
}

export default class ContributionsApi {
   public static getAll = async (): Promise<ContributionResp[]> => {
      const response = await axios.get(`/contributions`);
      return response.data?.data;
   };
}
